// @ts-strict-ignore
import React, { useState } from 'react'
import { Button } from '@mytours/components'
import strings from '../../../../../strings'
import { defineUserMobileDeviceOS } from '../../../functions'
import { useSelector } from 'react-redux'
import MessageToast from '../../MessageToast'
import { RootStoreState } from 'mytours-read-common'

const ShareButton: React.FC = () => {
	const [showCopiedToast, setShowCopiedToast] = useState(false)
	const socialSharingEnabled = useSelector(
		(state: RootStoreState) => state.settings.appMetaData?.social_sharing_enabled,
	)

	const handleShareButtonClick = async (): Promise<void> => {
		try {
			await navigator?.share({
				title: document.title,
				url: document.location.href,
			})
		} catch (err) {
			if (err instanceof Error && (err.name === 'AbortError' || err.name === 'InvalidStateError')) return
			try {
				await navigator.clipboard.writeText(document.location.href)
				setShowCopiedToast(true)
			} catch {
				const textArea = document.createElement('textarea')
				textArea.value = document.location.href
				document.body.appendChild(textArea)
				textArea.select()
				document.execCommand('copy')
				document.body.removeChild(textArea)
				setShowCopiedToast(true)
			}
		}
	}

	return navigator?.share !== undefined && socialSharingEnabled ? (
		<>
			{/* radius="0" carries over the `--border-radius: 0` this carried as an ion-button: the
			    default radius was cropping the icon. */}
			<Button
				variant="clear"
				radius="0"
				className="map-button"
				onClick={handleShareButtonClick}
				aria-label={strings.share}
			>
				<i className={`fal fa-${defineUserMobileDeviceOS() === 'Android' ? 'share-nodes' : 'arrow-up-from-square'}`} />
			</Button>
			<MessageToast
				isOpen={showCopiedToast}
				message="Link copied to clipboard"
				duration={2000}
				onDidDismiss={() => setShowCopiedToast(false)}
			/>
		</>
	) : null
}

export default ShareButton
